/* ORA: comportamento della card prodotto unica (snippets/ora-card.liquid).
   Tutto per delega sul documento, così funziona anche con le card aggiunte dopo
   (scorrimento infinito e filtri della collezione, ricerca, preferiti, consigliati).
   Dati di ogni card nel suo <script type="application/json" data-oc-dati>. */
(function () {
  'use strict';
  if (window.OraCard) return;

  var W = [360, 540, 720, 1080];
  var I = {
    ok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    giu: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  };
  var uid = 0;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function iu(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function ss(u) { return W.map(function (w) { return iu(u, w) + ' ' + w + 'w'; }).join(', '); }
  function dati(card) {
    if (!card._oc) {
      var s = card.querySelector('script[data-oc-dati]');
      try { card._oc = s ? JSON.parse(s.textContent) : null; } catch (e) { card._oc = null; }
    }
    return card._oc;
  }
  function voce(card, k) {
    var d = dati(card); if (!d || !d.it.length) return null;
    for (var i = 0; i < d.it.length; i++) if (d.it[i].k === k) return d.it[i];
    return d.it[0];
  }
  function attuale(card) { return voce(card, card.dataset.k); }
  function nome(v) { return v.n ? v.t + ' ' + v.n : v.t; }
  function annuncia(card, t) { var r = card.querySelector('.oc__live'); if (!r) return; r.textContent = ''; setTimeout(function () { r.textContent = t; }, 30); }
  function riga(v) { var x = v.x || !v.d ? 'Esaurito' : v.c; return v.n ? v.n + (x ? ' · ' + x : '') : x; }

  /* ===== avvio di una card ===== */
  function init(card) {
    card.setAttribute('data-oc-ok', '');
    card._oc = null; card._caldo = false; card._modo = 'unica';
    if (!dati(card)) return;
    var t = card.querySelector('.oc__t');
    if (t) { t.id = 'oc-t-' + (++uid); card.setAttribute('aria-labelledby', t.id); }
    card._k0 = card.dataset.k;
    var s = card.querySelector('.oc__s'); card._s0 = s ? s.textContent : '';
    pannello(card);
  }
  function scan() {
    var nuove = document.querySelectorAll('[data-oc]:not([data-oc-ok])');
    if (!nuove.length) return;
    nuove.forEach(init);
    if (window.OraPref) window.OraPref.aggiorna();
  }

  /* seconda foto e foto degli altri colori solo quando serve */
  function carica2(card, v) {
    var i2 = card.querySelector('.oc__i2');
    if (!i2 || !v || !v.b || i2.dataset.u === v.b) return;
    i2.dataset.u = v.b; i2.srcset = ss(v.b); i2.src = iu(v.b, 720);
  }
  function scalda(card) {
    if (card._caldo || card.classList.contains('oc--c')) return;
    card._caldo = true;
    var d = dati(card); if (!d) return;
    carica2(card, attuale(card));
    var i1 = card.querySelector('.oc__i1'), sz = i1 ? i1.getAttribute('sizes') : '';
    d.it.forEach(function (v) { if (v.a) { var im = new Image(); if (sz) im.sizes = sz; im.srcset = ss(v.a); } });
  }

  /* ===== cambio pallino: foto, link, titolo, prezzo, riga colore, cuore, taglie ===== */
  function mostra(card, k, anima) {
    var v = voce(card, k); if (!v) return;
    card.dataset.k = v.k;
    var i1 = card.querySelector('.oc__i1');
    if (v.a && i1 && i1.dataset.u !== v.a) {
      if (anima) {
        i1.classList.add('is-sw');
        var t = setTimeout(function () { i1.classList.remove('is-sw'); }, 700);
        i1.onload = function () { clearTimeout(t); i1.classList.remove('is-sw'); };
      }
      i1.dataset.u = v.a; i1.srcset = ss(v.a); i1.src = iu(v.a, 720);
    }
    var i2 = card.querySelector('.oc__i2');
    card.classList.toggle('no-b', !v.b || card.classList.contains('oc--c'));
    if (i2 && !v.b) { i2.removeAttribute('src'); i2.removeAttribute('srcset'); i2.dataset.u = ''; }
    else if (card._caldo) carica2(card, v);
    card.querySelectorAll('.oc__im, .oc__t a').forEach(function (a) { a.href = v.u; });
    var ta = card.querySelector('.oc__t a'); if (ta) { ta.textContent = v.t; ta.title = v.t; }
    var p = card.querySelector('.oc__p'); if (p) p.textContent = v.p;
    var pc = card.querySelector('.oc__pc'); if (pc) { pc.textContent = v.pc || ''; pc.hidden = !v.pc; }
    var s = card.querySelector('.oc__s');
    if (s) { s.textContent = card.hasAttribute('data-oc-fisso') && v.k === card._k0 ? card._s0 : riga(v); s.hidden = !s.textContent; }
    var chip = card.querySelector('.oc__chip');
    if (chip) {
      var et = chip.getAttribute('data-et') || '';
      chip.textContent = v.x ? 'Esaurito' : et;
      chip.hidden = !chip.textContent;
    }
    var h = card.querySelector('.oc__hrt'); if (h) h.setAttribute('data-ora-pref', v.f);
    card.querySelectorAll('.oc__c').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.k === v.k ? 'true' : 'false'); });
    card._modo = 'unica';
    pannello(card);
    if (window.OraPref) window.OraPref.aggiorna();
  }

  /* ===== aggiunta rapida ===== */
  function pannello(card) {
    var qa = card.querySelector('.oc__qa'); if (!qa) return;
    var d = dati(card), v = attuale(card);
    card.classList.remove('is-open');
    var pl = card.querySelector('.oc__plus');
    if (!d || !v || v.x || !v.z || !v.z.length) { qa.hidden = true; qa.innerHTML = ''; if (pl) pl.hidden = true; card.classList.remove('is-qa'); return; }
    qa.hidden = false; if (pl) pl.hidden = false;
    if (d.s && card._modo === 'pezzi' && v.o && v.o.length) return pezzi(card, d, v, qa);
    var tutteOut = !v.z.some(function (t) { return t[2]; });
    var h = d.s ? 'Stessa taglia per tutto il set' : (tutteOut ? 'Esaurito in questo colore' : (d.q || 'Aggiungi al carrello'));
    qa.innerHTML = '<p class="oc__qh">' + esc(h) + '</p><div class="oc__qs">'
      + v.z.map(function (t) {
        var lab = t[2] ? 'Aggiungi ' + nome(v) + ' taglia ' + t[0] + (d.s ? ' per tutti i pezzi' : '') + ' al carrello' : 'Taglia ' + t[0] + ' esaurita';
        return '<button type="button" data-oc-id="' + t[1] + '" data-oc-t="' + esc(t[0]) + '" aria-label="' + esc(lab) + '"' + (t[2] ? '' : ' disabled') + '>' + esc(t[0]) + '</button>';
      }).join('') + '</div>'
      + (d.s && v.o && v.o.length > 1 ? '<button type="button" class="oc__alt" data-oc-modo="pezzi">Taglie diverse per ogni pezzo</button>' : '');
  }

  /* set, taglie diverse per ogni pezzo: una tendina per pezzo, variante = combinazione fra le varianti vere */
  function pezzi(card, d, v, qa) {
    qa.innerHTML = '<p class="oc__qh" data-oc-msg>Scegli la taglia di ogni pezzo</p><div class="oc__dds"></div>'
      + '<button type="button" class="oc__add">Aggiungi il set</button>'
      + '<button type="button" class="oc__alt" data-oc-modo="unica">Stessa taglia per tutto il set</button>';
    var box = qa.querySelector('.oc__dds');
    v.o.forEach(function (op, i) {
      var id = 'oc-dd-' + (++uid);
      var el = document.createElement('div');
      el.className = 'oc-dd'; el.dataset.i = i; el.dataset.v = '';
      el.innerHTML = '<button type="button" class="oc-dd__btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '" aria-label="' + esc(op[0]) + ', scegli la taglia">'
        + '<span class="oc-dd__l">' + esc(op[0]) + '</span><span class="oc-dd__v ph">Taglia</span>' + I.giu + '</button>'
        + '<ul class="oc-dd__list" role="listbox" id="' + id + '" tabindex="-1" aria-label="Taglia ' + esc(op[0]) + '"></ul>';
      box.appendChild(el);
    });
  }
  function scelte(card) { return [].map.call(card.querySelectorAll('.oc-dd'), function (x) { return x.dataset.v || null; }); }
  function libera(v, sc, i, val) {
    return v.v.some(function (x) {
      if (!x[1] || x[2][i] !== val) return false;
      for (var j = 0; j < sc.length; j++) if (j !== i && sc[j] && x[2][j] !== sc[j]) return false;
      return true;
    });
  }
  function disegnaLista(card, dd) {
    var v = attuale(card), i = +dd.dataset.i, sc = scelte(card), op = v.o[i], sel = dd.dataset.v, list = dd.querySelector('.oc-dd__list');
    list.innerHTML = op[1].map(function (val, n) {
      var ok = libera(v, sc, i, val);
      return '<li role="option" id="' + list.id + '-' + n + '" data-v="' + esc(val) + '" aria-selected="' + (val === sel) + '"' + (ok ? '' : ' aria-disabled="true"') + '>'
        + (ok ? '<span>' + esc(val) + '</span>' : '<s>' + esc(val) + '</s><em>Esaurita</em>') + '</li>';
    }).join('');
  }
  function segna(dd) {
    var its = dd.querySelectorAll('li'), a = dd._act, list = dd.querySelector('.oc-dd__list');
    its.forEach(function (li, n) { li.classList.toggle('act', n === a); });
    if (a > -1 && its[a]) list.setAttribute('aria-activedescendant', its[a].id); else list.removeAttribute('aria-activedescendant');
  }
  function apriDD(card, dd, fuoco) {
    chiudiDD(dd);
    disegnaLista(card, dd);
    dd.classList.add('open'); dd.querySelector('.oc-dd__btn').setAttribute('aria-expanded', 'true');
    card.classList.add('is-open');
    var its = [].slice.call(dd.querySelectorAll('li'));
    dd._act = its.findIndex(function (li) { return li.dataset.v === dd.dataset.v; });
    if (dd._act < 0) dd._act = its.findIndex(function (li) { return !li.hasAttribute('aria-disabled'); });
    segna(dd);
    if (fuoco !== false) dd.querySelector('.oc-dd__list').focus({ preventScroll: true });
  }
  function chiudiDD(tranne, fuoco) {
    document.querySelectorAll('.oc-dd.open').forEach(function (dd) {
      if (dd === tranne) return;
      dd.classList.remove('open'); dd.querySelector('.oc-dd__btn').setAttribute('aria-expanded', 'false');
      var c = dd.closest('[data-oc]'); if (c && !c.querySelector('.oc-dd.open')) c.classList.remove('is-open');
      if (fuoco) dd.querySelector('.oc-dd__btn').focus({ preventScroll: true });
    });
  }
  function scegli(card, dd, li) {
    if (!li || li.hasAttribute('aria-disabled')) return;
    dd.dataset.v = li.dataset.v;
    dd.classList.remove('is-miss');
    var val = dd.querySelector('.oc-dd__v'); val.textContent = li.dataset.v; val.classList.remove('ph');
    var op = attuale(card).o[+dd.dataset.i];
    dd.querySelector('.oc-dd__btn').setAttribute('aria-label', op[0] + ': ' + li.dataset.v);
    chiudiDD(null, false);
    dd.classList.remove('open'); dd.querySelector('.oc-dd__btn').setAttribute('aria-expanded', 'false');
    dd.querySelector('.oc-dd__btn').focus({ preventScroll: true });
    var msg = card.querySelector('[data-oc-msg]'); if (msg && !card.querySelector('.oc-dd.is-miss')) msg.textContent = 'Scegli la taglia di ogni pezzo';
  }
  function aggiungiSet(card, btn) {
    var v = attuale(card), sc = scelte(card), msg = card.querySelector('[data-oc-msg]');
    var manca = [];
    card.querySelectorAll('.oc-dd').forEach(function (dd, i) { if (!sc[i]) { manca.push(v.o[i][0]); dd.classList.add('is-miss'); } });
    if (manca.length) {
      msg.textContent = 'Scegli la taglia di: ' + manca.join(', ');
      annuncia(card, msg.textContent);
      var f = card.querySelector('.oc-dd.is-miss .oc-dd__btn'); if (f) f.focus({ preventScroll: true });
      return;
    }
    var x = v.v.filter(function (y) { return y[2].every(function (val, i) { return val === sc[i]; }); })[0];
    if (!x || !x[1]) { msg.textContent = 'Combinazione esaurita'; annuncia(card, msg.textContent); return; }
    btn.disabled = true;
    var cosa = nome(v) + ', ' + v.o.map(function (op, i) { return op[0] + ' ' + sc[i]; }).join(', ');
    aggiungi(x[0]).then(function () { esito(card, cosa); }, function (e) { btn.disabled = false; errore(card, e); });
  }

  /* /cart/add.js e poi evento cart:update, come la sezione Novità */
  function aggiungi(id) {
    var ids = [].map.call(document.querySelectorAll('cart-items-component'), function (e) { return e.dataset.sectionId; }).filter(Boolean);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: ids.join(',') })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'Non disponibile');
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ora-card', data: { source: 'ora-card', itemCount: cart.item_count, sections: res.sections } } }));
        return cart;
      });
    });
  }
  function esito(card, cosa) {
    var qh = card.querySelector('.oc__qh');
    if (qh) qh.innerHTML = I.ok + 'Aggiunto al carrello';
    annuncia(card, 'Aggiunto al carrello: ' + cosa);
    setTimeout(function () { if (card.isConnected) pannello(card); }, 2500);
  }
  function errore(card, e) {
    var qh = card.querySelector('.oc__qh'), t = (e && e.message) || 'Riprova tra poco';
    if (qh) qh.textContent = t;
    annuncia(card, t);
    setTimeout(function () { if (card.isConnected && card._modo !== 'pezzi') pannello(card); }, 2500);
  }

  /* ===== eventi ===== */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var card = t.closest('[data-oc]');
    if (!card) { if (!t.closest('.oc-dd')) chiudiDD(); return; }
    if (!card.hasAttribute('data-oc-ok')) init(card);

    var c = t.closest('.oc__c');
    if (c) {
      e.preventDefault();
      if (c.dataset.k === card.dataset.k) return;
      scalda(card); mostra(card, c.dataset.k, true);
      var v = attuale(card);
      annuncia(card, (v.n || v.t) + (v.x || !v.d ? ', esaurito' : '') + ', ' + v.t);
      return;
    }
    var hrt = t.closest('.oc__hrt');
    if (hrt) {
      hrt.classList.remove('pop'); void hrt.offsetWidth; hrt.classList.add('pop');
      setTimeout(function () { annuncia(card, hrt.getAttribute('aria-pressed') === 'true' ? 'Aggiunto ai preferiti' : 'Rimosso dai preferiti'); }, 0);
      return;
    }
    var sb = t.closest('.oc__qs button');
    if (sb) {
      if (sb.disabled) return;
      var qa = card.querySelector('.oc__qa'), vv = attuale(card);
      qa.querySelectorAll('.oc__qs button').forEach(function (x) { x.disabled = true; });
      sb.classList.add('is-ok');
      aggiungi(sb.dataset.ocId).then(function () { esito(card, nome(vv) + ', taglia ' + sb.dataset.ocT); }, function (err) { errore(card, err); });
      return;
    }
    var alt = t.closest('.oc__alt');
    if (alt) {
      card._modo = alt.dataset.ocModo;
      pannello(card);
      var f = card.querySelector(card._modo === 'pezzi' ? '.oc-dd__btn' : '.oc__qs button:not(:disabled)');
      if (f) f.focus({ preventScroll: true });
      return;
    }
    var add = t.closest('.oc__add');
    if (add) { if (!add.disabled) aggiungiSet(card, add); return; }
    var db = t.closest('.oc-dd__btn');
    if (db) {
      var dd = db.closest('.oc-dd');
      if (dd.classList.contains('open')) chiudiDD(null); else apriDD(card, dd);
      return;
    }
    var li = t.closest('.oc-dd__list li');
    if (li) { scegli(card, li.closest('.oc-dd'), li); return; }
    if (!t.closest('.oc-dd')) chiudiDD();
  });

  document.addEventListener('keydown', function (e) {
    var list = e.target.closest && e.target.closest('.oc-dd__list');
    if (!list) return;
    var dd = list.closest('.oc-dd'), card = dd.closest('[data-oc]'), its = [].slice.call(list.children), k = e.key;
    function passo(d) {
      var i = dd._act;
      for (var n = 0; n < its.length; n++) { i = (i + d + its.length) % its.length; if (!its[i].hasAttribute('aria-disabled')) { dd._act = i; break; } }
      segna(dd);
    }
    if (k === 'ArrowDown') { e.preventDefault(); passo(1); }
    else if (k === 'ArrowUp') { e.preventDefault(); passo(-1); }
    else if (k === 'Enter' || k === ' ') { e.preventDefault(); scegli(card, dd, its[dd._act]); }
    else if (k === 'Escape') { e.preventDefault(); e.stopPropagation(); chiudiDD(null, true); }
    else if (k === 'Tab') { chiudiDD(null); }
  });

  function caldo(e) { var card = e.target.closest && e.target.closest('[data-oc]'); if (card) { if (!card.hasAttribute('data-oc-ok')) init(card); scalda(card); } }
  document.addEventListener('pointerover', function (e) { if (e.pointerType === 'mouse') caldo(e); }, { passive: true });
  document.addEventListener('focusin', caldo);

  /* card aggiunte dopo: scorrimento infinito, filtri, ricerca, preferiti, consigliati */
  var attesa = false;
  new MutationObserver(function () {
    if (attesa) return; attesa = true;
    requestAnimationFrame(function () { attesa = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();

  window.OraCard = { scan: scan, aggiungi: aggiungi };
})();

/* ORA: bottone + sulla foto (prodotti singoli) che apre le taglie senza andare alla pagina */
(function () {
  function chiudi(tranne) { document.querySelectorAll('.oc.is-qa').forEach(function (c) { if (c === tranne) return; c.classList.remove('is-qa'); var b = c.querySelector('.oc__plus'); if (b) b.setAttribute('aria-expanded', 'false'); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.oc__plus');
    if (b) { e.preventDefault(); var c = b.closest('.oc'); var ap = !c.classList.contains('is-qa'); chiudi(c); c.classList.toggle('is-qa', ap); b.setAttribute('aria-expanded', String(ap)); if (ap) { var f = c.querySelector('.oc__qa button:not([disabled])'); if (f) f.focus({ preventScroll: true }); } return; }
    if (!(e.target.closest && e.target.closest('.oc__qa'))) chiudi();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') chiudi(); });
})();
